import React, { Component } from 'react';
import { Breadcrumb } from '@blueprintjs/core'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import ReactGA from 'react-ga'



class Projects extends Component {
     componentDidMount() {
            ReactGA.pageview(window.location.pathname + window.location.search);
        }
        render() {

       
        return (
            <div>
                <ul className="pt-breadcrumbs">
                    <li><Breadcrumb href="/home" text="Home" /></li>
                    <li><Breadcrumb href="/projects" text="Projects" /></li>
                </ul>
                <hr />
                <div>
                    <h3>Projects</h3>
                    <div>
                    <p>Here you will find a list of all my current
                 and past projects! Feel free to contact me
                 with any questions or business inquiries.</p>

                <ul className="pt-list">
                <li><a  href="https://play.google.com/store/apps/details?id=com.forrestsmietanski.pingpongscorekeeper">Ping Pong score keeper - <FontAwesomeIcon icon={["fab", "android"]} /></a></li>

                    <li><a  href="https://www.forrestsmietanski.com/">ForrestSmietanski.com - <FontAwesomeIcon icon={["fab", "react"]} /></a></li>
                    
                    <li><a href="http://www.aonsquadlife.com/">aonsquadlife.com - <FontAwesomeIcon icon={["fab", "angular"]} /></a></li>
                </ul>
                    </div>
                </div>
            </div>

        );
    }
}

export default Projects;


// WEBPACK FOOTER //
// ./src/components/Projects.jsx